// import jquery from "jquery";
// window.$ = window.jQuery = jquery;

// console.log("jQuery loaded:", window.jQuery);
// console.log("jQuery version:", window.jQuery.fn?.jquery);

// console.log("i am updating.00000..xxx");
// Entry point for the build script in your package.jso
import { Application } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

window.Turbo = Turbo;

import "./controllers"; // This will load your index.js file which registers all controllers
import "./smhat_web";

import * as bootstrap from "bootstrap"
//import "bootstrap/dist/js/bootstrap.bundle.min.js";


import C4Radar from "./comet_scripts/c4radar";
window.C4Radar = C4Radar;

import C4BessEllipse from "./comet_scripts/c4_bess_ellipse";
window.C4BessEllipse = C4BessEllipse;

import jquery from "jquery";
window.$ = window.jQuery = jquery;

// import "./comet_scripts/c3_bess_visualizer";

function analyticsDebugModeEnabled() {
  try {
    return window.localStorage.getItem("ga_debug") === "true";
  } catch (_error) {
    return false;
  }
}

function trackAnalyticsEvent(eventName, params = {}) {
  if (typeof window.gtag !== "function") return;

  const eventParams = {
    ...params,
    ...(analyticsDebugModeEnabled() ? { debug_mode: true } : {})
  };

  window.gtag("event", eventName, eventParams);
}

window.trackAnalyticsEvent = trackAnalyticsEvent;

document.addEventListener("turbo:load", () => {
  trackAnalyticsEvent("page_view", {
    page_location: window.location.href,
    page_path: window.location.pathname,
    page_title: document.title
  });
});


import tippy from 'tippy.js';
// import 'tippy.js/dist/tippy.css';

function initializeTippyTooltips() {
  // console.log(Date.now() + " Hello from tippy's turbo:load");
  const tooltipTargets = document.querySelectorAll('.tooltip-target');

  tooltipTargets.forEach(target => {
    const contentId = target.getAttribute('data-tooltip-content');
    const contentElement = document.querySelector(contentId);

    if (!contentElement || target._tippy) return;

    const maxWidth = Number(target.getAttribute('data-tooltip-max-width')) || 350;

    tippy(target, {
      content: contentElement.innerHTML,
      allowHTML: true,
      placement: 'top',
      theme: 'light-border',
      interactive: true,
      maxWidth: maxWidth
    });
  });
}

function initializeBootstrapPopovers() {
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
  ;[...popoverTriggerList].forEach(popoverTriggerEl => bootstrap.Popover.getOrCreateInstance(popoverTriggerEl))
}

function initializeBootstrapTooltips() {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  ;[...tooltipTriggerList].forEach(tooltipTriggerEl => bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl))
}

document.addEventListener('turbo:load', function() {
  initializeTippyTooltips();
  initializeBootstrapPopovers();
  initializeBootstrapTooltips();
  initializeSmhatMeasureToggles();
});

document.addEventListener('DOMContentLoaded', function() {
  initializeSmhatMeasureToggles();
});

document.addEventListener('turbo:frame-load', function() {
  initializeSmhatMeasureToggles();
});

function initializeSmhatMeasureToggles() {
  document.querySelectorAll("[data-smhat-secondary-toggle]").forEach((button) => {
    if (button.dataset.smhatToggleInitialized === "true") return;
    button.dataset.smhatToggleInitialized = "true";
    setSmhatMeasureMode(smhatMeasureContainer(button), false);

    button.addEventListener("click", () => {
      const currentContainer = smhatMeasureContainer(button);
      setSmhatMeasureMode(currentContainer, currentContainer.dataset.smhatShowingSecondary !== "true");
    });
  });
}

function smhatMeasureContainer(button) {
  return button.closest("turbo-frame") || button.closest("[data-smhat-measure-table]") || button.closest(".card") || document;
}

function setSmhatMeasureMode(container, showSecondary) {
  container.dataset.smhatShowingSecondary = String(showSecondary);

  container.querySelectorAll(".smhat-primary-measure").forEach((element) => {
    element.classList.toggle("d-none", showSecondary);
  });

  container.querySelectorAll(".smhat-secondary-measure").forEach((element) => {
    element.classList.toggle("d-none", !showSecondary);
  });

  container.querySelectorAll("[data-smhat-secondary-toggle]").forEach((button) => {
    button.textContent = showSecondary ? "Show primary" : "Show secondary";
    button.setAttribute("aria-pressed", String(showSecondary));
  });
}

const shouldAnnounce = false;


document.addEventListener("turbo:submit-end", (event) => {
  // console.log("turbo:submit-end event.detail.success: " + event.detail.success);
  const statusModal = document.getElementById("athlete-status-modal");

  if (!statusModal) {
    // console.log("No statusModal found");
    return;
  }

  if (!statusModal.contains(event.target)) {
    return;
  }

  const bootstrapModal = bootstrap.Modal.getInstance(statusModal);

  if (!event.detail.success) {
    // console.log("turbo:submit-end failure - keeping the modal open");
    if (!bootstrapModal) {
      new bootstrap.Modal(statusModal).show();
    } else {
      bootstrapModal.show();
    }
  } else {
    // console.log("turbo:submit-end success - hiding the modal");
    if (bootstrapModal) {
      bootstrapModal.hide();
    }
  }
});



// // Function to attach click listeners to sort links
// function attachSortLinkListeners() {
//   document.querySelectorAll('a.sort_link').forEach(link => {
//     link.addEventListener('click', function() {
//       document.getElementById('progress-indicator').style.display = 'block';  // Show spinner on click
//     });
//   });
// }

// Function to show a small spinner next to the clicked sort link
function showSpinnerNextToLink(link) {
  // Create the spinner element
  let spinner = document.createElement('span');
  // spinner.classList.add('spinner-border', 'spinner-border-sm', 'small-spinner');
  spinner.classList.add('spinner-grow', 'spinner-grow-sm', 'small-spinner');
  spinner.setAttribute('role', 'status');

  // Insert the spinner after the clicked link
  link.insertAdjacentElement('afterend', spinner);

  // Show the spinner
  spinner.style.visibility = 'visible';

  return spinner;  // Return the spinner element so we can remove it later
}

function attachSortLinkListeners() {
  document.querySelectorAll('a.sort_link').forEach(link => {
    link.addEventListener('click', function() {
      // Remove any existing spinner from previous clicks
      let existingSpinner = document.querySelector('.small-spinner');
      if (existingSpinner) {
        existingSpinner.remove();
      }

      // Show spinner next to the clicked link
      let spinner = showSpinnerNextToLink(this);

      // Hide the spinner after the request completes
      document.addEventListener('turbo:before-fetch-response', function() {
        spinner.remove();  // Remove the spinner once the response is received
      }, { once: true });  // Use { once: true } to ensure this event listener runs only once
    });
  });
}

function attachSearchSubmitListeners() {

  document.querySelectorAll('form').forEach(form => {
    // console.log("Found a search querySelectorAll('form')");
    form.addEventListener('submit', function(event) {

      const submitButton = form.querySelector('button.search');
      const spinner = form.querySelector('span.spinner-grow');

      if (!spinner) {
        return;
      }

      spinner.classList.remove('d-none');

      // Disable the button to prevent multiple clicks
      submitButton.disabled = true;

      // Hide the spinner after the request completes
      document.addEventListener('turbo:before-fetch-response', function() {
        spinner.classList.add('d-none');
        // Remove the spinner once the response is received
      }, { once: true });  // Use { once: true } to ensure this event listener runs only once
    });

  });


}

// Initial attachment of event listeners
attachSortLinkListeners();
attachSearchSubmitListeners();

// Reattach event listeners after Turbo Frame is updated
document.addEventListener('turbo:frame-load', function() {
  attachSortLinkListeners();  // Reattach event listeners after Turbo updates the frame
  attachSearchSubmitListeners();
});


document.addEventListener("turbo:load", function() {
  announcement(Date.now() + "I AM ALIVE UPP IN HERE: turbo:load");
});

document.addEventListener("turbo:click", function() {
  announcement(Date.now() + "I AM ALIVE UPP IN HERE: turbo:click");
});

document.addEventListener("turbo:before-render", function() {
  announcement(Date.now() + "I AM ALIVE UPP IN HERE: turbo:before-render");
});

document.addEventListener("turbo:render", function() {
  announcement(Date.now() + "I AM ALIVE UPP IN HERE: turbo:render");
});

function announcement(the_announcement) {
  if(shouldAnnounce) {
    console.log(Date.now() + " " + the_announcement);
  }
}
